import { isEmptyObject } from "../../../utils/tests";
import { CompetitionCalendarAndResultsQuery } from '../types';

/**
 * typeguard for CompetitionCalendarAndResultsQuery
 * @param CompetitionCalendarAndResultsQuery object passed to transformer
 */
export const isValidCompetitionCalendarAndResults = (obj: CompetitionCalendarAndResultsQuery): boolean => Boolean(obj?.data?.competitionCalendarAndResults && !isEmptyObject(obj.data.competitionCalendarAndResults));
